// @flow

import { createSelector } from 'reselect';

import { selectHasDomainTransfer } from 'src/Cart/Setup/modules/selectors';
import type { FullState } from 'src/types';

export type NavigationMode = 'continue' | 'configure';

export const selectNavigationMode: (state: FullState) => NavigationMode =
  createSelector([selectHasDomainTransfer], hasDomainTransfer =>
    hasDomainTransfer ? 'configure' : 'continue',
  );
